import { gql } from '@apollo/client';

export const StudentOnlineApplicationFragment = gql`
    fragment StudentOnlineApplication on StudentOnlineApplication {
        id
        step
        status
        active
        ageLimits {
            isAdult
            isFutureAdult
        }
        deadline {
            interactive
            fill
            chat
        }
        responsible {
            fullName
            birthdate
            passportSerial
            passportNumber
            passportIssued
            passportAddress
            address
            phone
            email
        }
        recreation {
            selfLeft
            count
            fromAge
            assesment
            mood
        }
        documents {
            type
            name
            description
            hint
            template
            example
            status
            files {
                variant
                title
                description
                hint
                example
                uploadTitle
                documentRefTitle
                documentRefChosenTitle
                documentRef
                file {
                    id
                    name
                }
            }
        }
        nearestLap {
            id
            to
        }
        student {
            id
            fullName
            fullNameGenitive
            birthdate
            passportSerial
            passportNumber
            passportIssued
            passportAddress
            address
            phone
            email
            school {
                id
                fullName
                shortName
            }
            medical {
                diets
                proneToColdBool
                proneToCold
                fractures
                headInjuries
                allergicDiseases
                allergyMedications
                chronicDiseases
                medications
                heatTransfer
                motionSicknessBool
                motionSickness
                insectBites
                healthSpecials
                fatigueBool
                fatigue
                wearingGlassesBool
                wearingGlasses
                fearDarkBool
                fearDark
                otherSpecials
            }
            individual {
                wantToServe
                sports
                pleasureActivities
                specialSkills
                unPleasureActivities
                stressfulSituations
                attitudeThings
                selfCare
                needToControlled
                needToControlledOther
                preferCommunicate
                communationDifficulties
                characterTraits
                badHabits
            }
            parents {
                name
                birthdate
                passportSerial
                passportNumber
                passportIssued
                passportAddress
                address
                phone
                email
            }
            socials {
                vk
                telegram
            }
        }
    }
`;
